import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.flat-map.js";
import VideoPlayer from '@/components/widget/VideoPlayer';
import GridItem from '@/components/video-list/GridItem';
import VideoService from '@/services/VideoService';
import { bus } from '@/eventBus';
export default {
  props: {
    video: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    VideoPlayer,
    GridItem
  },
  data() {
    return {
      videoOptions: {
        disablePictureInPicture: true,
        controls: true,
        autoplay: true,
        responsive: true,
        fluid: true,
        sources: []
      },
      sharebox: false,
      loading: false,
      localFavorite: false,
      relatedLoading: false,
      relatedVideos: []
    };
  },
  computed: {
    performerLabel() {
      if (!this.video || !this.video.video || !this.video.video.ensemble) {
        return '';
      }
      const org = this.video.video.ensemble.organization ? this.video.video.ensemble.organization.name : '';
      const ensemble = this.video.video.ensemble.name || '';
      if (org && ensemble && org !== ensemble) {
        return `${org} — ${ensemble}`;
      }
      return ensemble || org;
    },
    currentChannelId() {
      return this.video.video.networkchannel_id || null;
    },
    moreFromChannel() {
      return this.relatedVideos.filter(item => item && item.id !== this.video.id).slice(0, 4);
    }
  },
  watch: {
    video: {
      immediate: true,
      deep: true,
      handler(val) {
        this.localFavorite = !!(val && val.favorite);
        this.setVideo();
        this.fetchMoreFromChannel();
      }
    }
  },
  methods: {
    setVideo() {
      this.videoOptions.sources = [];
      if (this.video && this.video.playlist_link) {
        this.videoOptions.sources.push({
          src: this.video.playlist_link,
          type: 'application/x-mpegURL'
        });
      }
    },
    clearVideo() {
      if (this.$route.name === 'Watch Video') {
        this.$router.push('/video/channel');
      } else {
        bus.$emit('clearVideo');
        this.$emit('clear-video');
      }
    },
    favorite() {
      VideoService.favorite(this.video.id).then(() => {
        this.localFavorite = !this.localFavorite;
        this.$emit('update-video-favorite-status', {
          id: this.video.id,
          favorite: this.localFavorite,
          video: this.video
        });
      }).catch(error => {
        this.$aim.error(error.response);
      });
    },
    toggleShare() {
      this.sharebox = !this.sharebox;
    },
    copy() {
      const copyElement = document.createElement('textarea');
      copyElement.style.position = 'fixed';
      copyElement.style.opacity = '0';
      copyElement.value = decodeURI(this.video.shareableLink || '');
      document.body.appendChild(copyElement);
      copyElement.select();
      document.execCommand('copy');
      document.body.removeChild(copyElement);
    },
    async fetchMoreFromChannel() {
      if (!this.currentChannelId) {
        this.relatedVideos = [];
        return;
      }
      this.relatedLoading = true;
      try {
        const payload = {
          filters: {
            channel_id: this.currentChannelId
          },
          pagination: {
            page: 1,
            perPage: 12,
            rows: 1,
            numPages: 1
          },
          list: null
        };
        const response = await VideoService.channelVideos(payload);
        const tabs = Array.isArray(response.data.videos) ? response.data.videos : [];
        const flattened = tabs.flatMap(tab => Array.isArray(tab.results) ? tab.results : []);
        const deduped = flattened.filter((item, index, arr) => {
          return item && item.id && arr.findIndex(v => v.id === item.id) === index;
        });
        this.relatedVideos = deduped.filter(item => item.id !== this.video.id);
      } catch (error) {
        this.relatedVideos = [];
        this.$aim.error(error.response);
      } finally {
        this.relatedLoading = false;
      }
    },
    playRelated(id) {
      bus.$emit('clearVideo');
      VideoService.fetch(id).then(response => {
        bus.$emit('videoSelected', response.data);
      }).catch(err => {
        this.$aim.notify(err.response);
      });
    },
    updateRelatedFavoriteStatus({
      id,
      favorite,
      video
    }) {
      const idx = this.relatedVideos.findIndex(item => item.id === id);
      if (idx !== -1) {
        this.relatedVideos[idx] = {
          ...this.relatedVideos[idx],
          favorite
        };
      }
      this.$emit('update-video-favorite-status', {
        id,
        favorite,
        video
      });
    }
  }
};